import Axios from 'axios'

const collectionPoint = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  createCollectionPoint (item) {
    return this.axios().post('/collectionPoint', item)
  },
  editCollectionPoint ({idCollectionPoint, name, laboratory}) {
    return this.axios().put('/collectionPoint', {
      idCollectionPoint,
      name,
      laboratory
    })
  },
  deleteCollectionPoint (id) {
    return this.axios().put('/collectionPoint/delete/' + id)
  },
  getCollectionPoints (idLaboratory) {
    return this.axios().get('/collectionPoint/obtain-all/' + idLaboratory)
  }
}

export default collectionPoint
